<template>
  <div class="insurancePlan" :class="!_isMobile ? 'mt88' : 'warpMt'">
    <img :class="_isMobile ? 'bannerStyleM' : 'bannerStylePc'" :src="_isMobile ? 'https://cdn.youjiajk.com/insurancePlanMobile.png' : 'https://cdn.youjiajk.com/insurancePlanBannerPc_YS_new.png'" />
    <insurancePlanPc v-if="!_isMobile"></insurancePlanPc>
    <insurancePlanMobile v-else></insurancePlanMobile>
    <!-- <customizedService v-if="!_isMobile" text="众多大型商保公司的" colorText="专业选择"></customizedService> -->
  </div>
</template>

<script>
import insurancePlanPc from './pc/insurancePlanPc.vue'
import insurancePlanMobile from './mobile/insurancePlanMobile.vue'
import customizedService from '@/components/customizedServicePc'
  export default {
     metaInfo(){
      return {
        meta:[
          {
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name:'keywords',
            content:'优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false
      }
    },
    components: {
      insurancePlanPc,
      insurancePlanMobile,
      customizedService
    },
    created() {
      this._isMobile = this.$util._isMobile()
    },
  }
</script>

<style scoped lang="less">
.insurancePlan{
  display: flex;
  flex-direction: column;
}
.bannerStyleM {
  width: 100%;
  // height: 2.86rem;
  object-fit: cover;
}
.bannerStylePc {
  width: 100%;
  // height: 285px;
  object-fit: cover;
}
.mt88{
  margin-top: 88px;
}
.warpMt{
  margin-top: 1.55rem;
}
</style>


// WEBPACK FOOTER //
// src/views/insurancePlan.vue